import contenttype from '../templates/contenttype.js';
import display from '../utils/display.js';
export default class RelatedByTag {
  constructor(el) {
    this.el = el;
    this.category = this.el.dataset.tagCategory;
    this.tagPage = this.el.dataset.tagPage;
    if (window.tagconf) {
      console.log(window.tagconf);
      this.tagPage = window.tagconf.tag_page;
    }
    this.feedurl = `/feeds/tags/index.html/category/${this.category}/filter/`;
    this.currenturi = window.location.pathname;
    this.numberofitems = 100;
    this.tagsarray = this.el.dataset.tagsByValue
      ? this.el.dataset.tagsByValue.includes('|')
        ? this.el.dataset.tagsByValue.split('|')
        : this.el.dataset.tagsByValue.split(',')
      : [];
    this.tags = this.tagsarray.join('/');
    this.taglinks = [];
    if (this.tags) {
      // this.getrelated();
      this.outputtags();
    }
  }

  outputtags() {
    let contentarray = [];
    this.tagsarray.forEach((tag) => {
      if (tag && tag != '') {
        if (tag.includes('>')) {
          const tagarray = tag.split('>');
          tag = tagarray[tagarray.length - 1];
        }
        contentarray.push(
          `<a class="button reltag" href="${this.tagPage}?category=${encodeURIComponent(this.category.trim())}&tags=${encodeURIComponent(tag.trim())}">${tag.trim()}</a>`
        );
      }
    });

    const tile = contenttype.tile({
      heading: 'Tags',
      content: contentarray.join(''),
      span: '12',
      backgroundclass: 'TileBackgroundAlt2',
      extraclasses: 'related-by-tag-container no-bullet',
      fullwidthtext: true,
    });
    this.el.insertAdjacentHTML('afterend', tile);
    function getTiles() {
      return import(/* webpackChunkName: "gu-tiles" */ './tiles')
        .then(({ default: Tiles }) => {
          return Tiles;
        })
        .catch((error) => 'An error occurred while loading the component');
    }
    // if (document.querySelector('.related-by-tag-container')) {
    getTiles().then((Tiles) => {
      new Tiles('.related-by-tag-container');
      //images
      let last_known_scroll_position = 0;
      let ticking = false;
      display.lazyloadimages();
      window.addEventListener('scroll', function (e) {
        last_known_scroll_position = window.pageYOffset;
        if (!ticking) {
          window.requestAnimationFrame(function () {
            display.lazyloadimages();
            ticking = false;
          });
          ticking = true;
        }
      });
    });
    //   }
  }

  getrelated() {
    this.tagsarray.forEach((tag) => {
      //console.log(tag);
      fetch(`${this.feedurl}${tag}/${this.numberofitems}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.length > 0) {
            this.insertrelated(data, tag);
          }
        });
    });
  }

  insertrelated(data, tag) {
    //build ul
    let contentarray = [];
    data.results.forEach((object) => {
      //parse object.url to get pathname
      //let pathname = new URL(object.url).pathname;
      if (object.url !== this.currenturi) {
        contentarray.push(
          `<a class="button tag" href="${object.url}">${object.section_name}</a>`
        );
      }
    });

    const accordion = contenttype.accordion({
      heading: tag,
      headingtype: 'h3',
      content: contentarray.join(''),
    });
    const tile = contenttype.tile({
      heading: 'Related content',
      content: accordion,
      span: '12',
      backgroundclass: 'TileBackgroundAlt2',
      extraclasses: 'related-by-tag-container',
      fullwidthtext: true,
    });
    this.el.insertAdjacentHTML('afterend', tile);
    /**tiles */
    function getTiles() {
      return import(/* webpackChunkName: "gu-tiles" */ './tiles')
        .then(({ default: Tiles }) => {
          return Tiles;
        })
        .catch((error) => 'An error occurred while loading the component');
    }
    if (document.querySelector('.related-by-tag-container')) {
      getTiles().then((Tiles) => {
        new Tiles('.related-by-tag-container');
        //images
        let last_known_scroll_position = 0;
        let ticking = false;
        display.lazyloadimages();
        window.addEventListener('scroll', function (e) {
          last_known_scroll_position = window.pageYOffset;
          if (!ticking) {
            window.requestAnimationFrame(function () {
              display.lazyloadimages();
              ticking = false;
            });
            ticking = true;
          }
        });
      });
    }

    function getAccordion() {
      return import(/* webpackChunkName: "gu-accordion" */ './accordion')
        .then(({ default: Accordion }) => {
          return Accordion;
        })
        .catch((error) => 'An error occurred while loading the component');
    }
    if (document.querySelector('.racc')) {
      getAccordion().then((Accordion) => {
        new Accordion('racc');
      });
    }
  }
}
